import { computed, readonly, ref } from 'vue'

const _slug = ref<string | null>(null)

export function useQuickView() {
  function open(slug: string) {
    _slug.value = slug
  }

  function close() {
    _slug.value = null
  }

  return {
    activeSlug: readonly(_slug),
    isOpen: computed(() => _slug.value !== null),
    open,
    close,
  }
}
